import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { UserModel } from '../model/UserModel';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements  CanActivate{

  currentUser: UserModel;
  
  constructor(private router: Router, private authenticationService: AuthenticationService) {
  }
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    this.currentUser = this.authenticationService.getCurrentUser();

    if (this.currentUser) {

      return true;
    }
    else {
      this.router.navigateByUrl("/signin");
      return false;
    }

  }
}
